import { render, staticRenderFns } from "./SuspendedModal.vue?vue&type=template&id=8d139c50&scoped=true"
import script from "./SuspendedModal.vue?vue&type=script&lang=js"
export * from "./SuspendedModal.vue?vue&type=script&lang=js"
import style0 from "./SuspendedModal.vue?vue&type=style&index=0&id=8d139c50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d139c50",
  null
  
)

export default component.exports